export default __webpack_public_path__ + "static/media/scene_06.f8060b05.mp3";